import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import {Box, CircularProgress, Paper} from '@mui/material'
import Stack from '@mui/material/Stack'

import {classesIP} from '../selectedPersonaStyles'
import {ReactComponent as HospitalIcon} from '../../../../icons/Personas/engagement/Hospital Access.svg'
import {ReactComponent as PharmacyIcon} from '../../../../icons/Personas/engagement/Pharmacy Access.svg'
import {ReactComponent as TransportationIcon} from '../../../../icons/Personas/engagement/Transportation Insecurity.svg'
import {SuperscriptDagger} from '../../../common/Dagger'

const BarriersToOutcomes = ({
  engagementData,
  loadingPersonaEngagement,
  isZeroCountPopulation,
  handlePersonaCustomLabel
}) => {
  if (loadingPersonaEngagement) {
    return <CircularProgress className={classesIP.CircularProgress} size={15} title='loading' />
  }

  const HospitalAccess = 'Hospital Access'
  let hospitalAccessLabel = handlePersonaCustomLabel('engagement', HospitalAccess)
  hospitalAccessLabel = hospitalAccessLabel === HospitalAccess ? 'hospital' : hospitalAccessLabel.toLowerCase()

  const PharmacyAccess = 'Pharmacy Access'
  let pharmacyAccessLabel = handlePersonaCustomLabel('engagement', PharmacyAccess)
  pharmacyAccessLabel = pharmacyAccessLabel === PharmacyAccess ? 'pharmacy' : pharmacyAccessLabel.toLowerCase()

  return (
    <>
      <Typography className={classesIP.personaSubTitle} tabIndex={0} aria-label='Barriers to healthy outcomes Section'>
        {handlePersonaCustomLabel('engagement', 'BARRIERS TO HEALTHY OUTCOMES')}
      </Typography>

      <Box className={classesIP.Box}>
        <Paper className={classesIP.Paper} elevation={1}>
          <Box className={classesIP.SubStack}>
            <Box className={classesIP.StackChildHalf}>
              <Stack className={classesIP.overviewKeyChar1Stack} tabIndex={0}>
                <Stack direction='row' className={classesIP.overviewKeyChar1StackChild} spacing={1}>
                  <HospitalIcon className={classesIP.overviewKeyChar1Icon} />
                  <Typography className={classesIP.engagementPercent} variant='overline'>
                    {engagementData.hospitalAccess + '%'}
                    {isZeroCountPopulation && <SuperscriptDagger width={10} height={10} />}
                  </Typography>
                </Stack>
                <Typography className={classesIP.engagementText}>
                  {handlePersonaCustomLabel('engagement', 'Hospital Access')}
                </Typography>
                <Typography className={classesIP.engagementDetail} align='center'>
                  Percentage of individuals within 3 miles of nearest {hospitalAccessLabel}
                </Typography>
              </Stack>
            </Box>

            <Box className={classesIP.StackChildHalf}>
              <Stack className={classesIP.overviewKeyChar1Stack} tabIndex={0}>
                <Stack direction='row' className={classesIP.overviewKeyChar1StackChild} spacing={1}>
                  <PharmacyIcon className={classesIP.overviewKeyChar1Icon} />
                  <Typography className={classesIP.engagementPercent} variant='overline'>
                    {engagementData.pharmacyAccess + '%' || 'N/A'}
                    {isZeroCountPopulation && <SuperscriptDagger width={10} height={10} />}
                  </Typography>
                </Stack>
                <Typography className={classesIP.engagementText}>
                  {handlePersonaCustomLabel('engagement', 'Pharmacy Access')}
                </Typography>
                <Typography className={classesIP.engagementDetail} align='center'>
                  Percentage of individuals within 3 miles of nearest {pharmacyAccessLabel}
                </Typography>
              </Stack>
            </Box>

            <Box className={classesIP.StackChildFull}>
              <Box className={classesIP.Stack}>
                <Box className={classesIP.StackChildHalf}>
                  <Stack className={classesIP.overviewKeyChar1Stack} tabIndex={0}>
                    <Stack direction='row' className={classesIP.overviewKeyChar1StackChild} spacing={1}>
                      <TransportationIcon className={classesIP.overviewKeyChar1Icon} />
                      <Typography className={classesIP.engagementPercent} variant='overline'>
                        {engagementData.transportationInsecurity + '%'}
                        {isZeroCountPopulation && <SuperscriptDagger width={10} height={10} />}
                      </Typography>
                    </Stack>
                    <Typography className={classesIP.engagementText}>
                      {handlePersonaCustomLabel('engagement', 'Transportation Insecurity')}
                    </Typography>
                    <Typography className={classesIP.engagementDetail} align='center'>
                      Percentage of individuals with high{' '}
                      {handlePersonaCustomLabel('engagement', 'Transportation Insecurity').toLowerCase()} risk
                    </Typography>
                  </Stack>
                </Box>

                <Box className={classesIP.StackChildHalf} />
              </Box>
            </Box>
          </Box>
        </Paper>
      </Box>
    </>
  )
}

BarriersToOutcomes.propTypes = {
  engagementData: PropTypes.shape({
    hospitalAccess: PropTypes.number,
    pharmacyAccess: PropTypes.number,
    transportationInsecurity: PropTypes.number
  }).isRequired,
  loadingPersonaEngagement: PropTypes.bool.isRequired,
  isZeroCountPopulation: PropTypes.bool.isRequired,
  handlePersonaCustomLabel: PropTypes.func.isRequired
}

export default BarriersToOutcomes
